import React from 'react';
import propTypes from 'prop-types';
import { HashLink as LinkComponent } from 'react-router-hash-link';

import {
  EditWrapper,
  FileUploadWrapper,
} from '../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/personalInfo';
import { Edit } from '../../../../../editJournal/toolset/assets/icons';
import profileOpts from './profileOpts';
import DropDown from '../../../../../../../../../../common/components/Toolbar/ToolbarItems/DropDown';

const EditImage = (props) => {
  const {
    show,
    onChange,
    clearEventValue,
    dataTestId,
    handleOpenDropdown,
    handleCloseDropdown,
    handleRemoveDocumentPicture,
    logo,
    labelKey,
    iconSelector,
    createListing,
  } = props;
  return (
    <EditWrapper
      createListing={createListing}
      ref={iconSelector}
      onClick={handleOpenDropdown}
    >
      <Edit width="12px" height="12px" fill="white" dataTestId={dataTestId} />
      {show && (
        <DropDown
          className="profileOpts"
          parentMenuClassName="profileOptsMenu"
          childrenList={profileOpts({
            removeDocumentPicture: handleRemoveDocumentPicture,
          })}
          labelKey={labelKey}
          logo={logo}
          handleCloseDropdown={handleCloseDropdown}
          clickEvent
          LinkComponent={LinkComponent}
        />
      )}
      <FileUploadWrapper
        type="file"
        id={labelKey ? `Upload a photo-${labelKey}` : `Upload a photo`}
        name={labelKey ? `Upload a photo-${labelKey}` : `Upload a photo`}
        accept="image/png, image/jpeg"
        onChange={onChange}
        onClick={(e) => {
          e.stopPropagation();
          clearEventValue(e);
        }}
      />
    </EditWrapper>
  );
};

EditImage.propTypes = {
  show: propTypes.bool.isRequired,
  onChange: propTypes.func.isRequired,
  clearEventValue: propTypes.func.isRequired,
  dataTestId: propTypes.string.isRequired,
  handleOpenDropdown: propTypes.func.isRequired,
  handleCloseDropdown: propTypes.func.isRequired,
  handleRemoveDocumentPicture: propTypes.func.isRequired,
};

export default EditImage;
